<template>
  <div>
    <query-frame
      @addNew="showLocationModal"
      :add-text="handlePermission('locationAdd')?'新建货位':''"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      :current="page"
      :count="count">
      <div slot="queryParams" class="queryContainer">
        <div class="queryItem" v-if="roleType!==2">
          <label>门店名称:</label>
          <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
        </div>
        <div class="queryItem">
          <label>货位描述:</label>
          <lk-input class="item" v-model.trim="query.locationDescription" :maxlength="50" placeholder="货位描述..."></lk-input>
        </div>
        <div class="queryItem">
          <label>货位编码:</label>
          <lk-input class="item" v-model.trim="query.locationCode" :maxlength="50" placeholder="货位编码..."></lk-input>
        </div>
        <div class="queryItem">
          <label>所属仓库:</label>
          <lk-select class="item" filterable v-model="query.warehouseId">
            <lk-option
              v-for="item in warehouseAllList"
              :value="item.id"
              :key="item.id">{{ item.name }}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>是否有商品:</label>
          <lk-select class="item" v-model="query.hasGoods">
            <lk-option
              v-for="item in hasGoodsList"
              :value="item[0]"
              :key="item[0]">{{ item[1] }}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <lk-button type="primary" class="mr" @click="handleSearch">查询</lk-button>
          <lk-button @click="handleReset">重置</lk-button>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </query-frame>
    <!-- 新建||编辑货位弹出层 开始 -->
    <lk-modal v-model="locationModal.visiable" @on-cancel="handleCancel" :mask-closable="false">
      <div slot="header">
        <div class="header" v-if="locationModal.type === 2">
          <div class="title">
            <span>货位编码:</span>
            <span>{{locationForm.locationCode}}</span>
          </div>
          <div class="infos">
            <span>是否有商品:<label>{{hasGoodsList.get(locationForm.hasGoods)}}</label></span>
            <span>创建人:<label>{{locationForm.createUserName}}</label></span>
            <span>创建时间:<label>{{locationForm.createTime|formatDate}}</label></span>
          </div>
        </div>
        <h3 v-else>货位信息</h3>
      </div>
      <lk-form
        label-position="right"
        :label-width="130"
        :rules="locationFormRules"
        :model="locationForm"
        ref="locationForm">
        <lk-row :gutter="16">
          <lk-col span="20">
            <lk-form-item label="所属仓库:" prop="warehouseId">
              <lk-select v-model="locationForm.warehouseId" filterable :disabled="locationModal.type === 2">
                <lk-option v-for="item in warehouseAlbeList" :value="item.id" :key="item.id">{{ item.warehouseName }}</lk-option>
              </lk-select>
            </lk-form-item>
          </lk-col>
          <lk-col span="20" v-if="locationModal.type === 1">
            <lk-form-item label="货位编码:" prop="locationCode">
              <lk-input :maxlength="50" v-model.trim="locationForm.locationCode"></lk-input>
            </lk-form-item>
          </lk-col>
          <lk-col span="20">
            <lk-form-item label="货位描述:" prop="locationDescription">
              <lk-input :maxlength="50" v-model.trim="locationForm.locationDescription"></lk-input>
            </lk-form-item>
          </lk-col>
        </lk-row>
      </lk-form>
      <div slot="footer">
        <div class="btns">
          <lk-button @click="handleCancel">取消</lk-button>
          <lk-button type="primary" @click="handleSubmit" :loading="locationModal.loading">提交</lk-button>
        </div>
      </div>
    </lk-modal>
    <!-- 新建||编辑货位弹出层 结束 -->
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame';
import inventory from '../../services/inventory';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';

export default {
  mixins: [mapState, queryMixins],
  components: { QueryFrame },
  computed: {
    hasLocationEdit() {
      return this.handlePermission('locationEdit');
    },
  },
  data() {
    return {
      locationModal: {
        visiable: false, // 显隐货位弹出层
        type: null, // 1新建 2编辑
        loading: false,
      },
      locationForm: {
        warehouseId: null,
        locationCode: null,
        locationDescription: null,
      },
      locationFormRules: {
        warehouseId: [{
          required: true,
          message: '请此处为必填项，不能为空',
          trigger: 'blur',
          type: 'number',
        }],
        locationCode: [{
          required: true,
          message: '请此处为必填项，不能为空',
          trigger: 'blur',
        }],
        locationDescription: [{
          required: true,
          message: '请此处为必填项，不能为空',
          trigger: 'blur',
        }],
      },
      hasGoodsList: new Map().set(1, '有').set(2, '无'),
      query: {
        storeIdList: [],
        locationDescription: null,
        locationCode: null,
        warehouseId: null,
        hasGoods: null,
      },
      columns: [
        {
          title: '货位编码',
          key: 'locationCode',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '货位描述',
          key: 'locationDescription',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '所属仓库/货柜',
          key: 'warehouseName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '是否有商品',
          key: 'hasGoods',
          minWidth: 116,
          tooltip: true,
          render: (h, { row }) => h('span', this.hasGoodsList.get(row.hasGoods)),
        },
        {
          title: '创建人',
          key: 'createUserName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 116,
          tooltip: true,
          render: (h, { row }) => h('span', utils.exchangeTime(row.createTime)),
        },
        {
          title: '状态',
          key: 'isUsing',
          minWidth: 116,
          render: (h, { row }) => (this.hasLocationEdit ? h('lk-switch', {
            props: {
              size: 'large',
              value: row.isUsing === 1,
              loading: row.loading,
            },
            on: {
              'on-change': (value) => {
                row.loading = true;
                inventory.locationHandleStatus({
                  id: row.id,
                  status: value ? 1 : 2,
                  warehouseId: row.warehouseId,
                })
                  .then((res) => {
                    if (res.data.status === 200) {
                      this.$Message.success(value ? '该货位已启用' : '该货位已禁用');
                      row.loading = false;
                      this.getData();
                    } else {
                      row.loading = false;
                      this.$Message.error(res.data.error);
                      this.getData();
                    }
                  })
                  .catch((err) => {
                    this.getData();
                    utils.handleError(err);
                  });
              },
            },
          }, [
            h('span', {
              slot: 'open',
            }, '启用'),
            h('span', {
              slot: 'close',
            }, '禁用'),
          ]) : h('span', row.isUsing === 1 ? '启用' : '禁用')),
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 80,
          render: (h, { row }) => h('div', [
            this.hasLocationEdit ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: row.isUsing !== 1,
              },
              on: {
                click: () => {
                  this.showLocationModal(2);
                  this.getLocationInfo(row.id);
                },
              },
            }, '编辑') : null,
          ]),
        },
      ],
      warehouseAlbeList: [], // 非禁用状态的仓库列表 【! 所属仓库所有状态列表和非禁用状态列表的后台接口不是同一个 】
      warehouseAllList: [], // 所有状态仓库列表
      tableData: [],
    };
  },
  methods: {
    handleCancel() {
      this.locationForm = {};
      this.$refs.locationForm.resetFields();
      this.locationModal.visiable = false;
    },
    handleSubmit() {
      this.$store.commit('setDisableLoading', true);
      this.$refs.locationForm.validate((valid) => {
        if (valid) {
          const {
            warehouseId,
            locationCode,
            locationDescription,
            id,
          } = this.locationForm;

          // 执行新建或者编辑请求
          const finalFormAction = this.locationModal.type === 1 ? inventory.saveLocationData : inventory.updateLocationData;
          this.locationModal.loading = true;
          finalFormAction({
            warehouseId, locationCode, locationDescription, id,
          }).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success(this.locationModal.type === 1 ? '添加成功' : '更新成功');
              this.getData();
              this.handleCancel();
            } else {
              this.$Message.error(res.data.error);
            }
            this.locationModal.loading = false;
          })
            .catch((err) => {
              this.locationModal.loading = false;
              utils.handleError(err);
            });
        } else {
          this.$Message.error('请填写完整信息');
        }
      });
    },
    // 非禁用的仓库列表
    getWarehouseAbleList() {
      inventory.warehouseList({ status: 1 })
        .then((res) => {
          if (res.data.status === 200) {
            this.warehouseAlbeList = res.data.data.list;
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    // 所属仓库列表
    getWarehouseList() {
      inventory.inventoryNameList()
        .then((res) => {
          if (res.data.status === 200) {
            this.warehouseAllList = res.data.data;
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      inventory.getLocationData(this.params)
        .then((res) => {
          if (res.data.status === 200) {
            this.tableData = res.data.data.list;
            this.count = res.data.data.count;
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    showLocationModal(type = 1) {
      this.locationModal.type = type;
      this.locationModal.visiable = true;
    },
    handleReset() {
      this.query = {};
    },
    getLocationInfo(id) {
      inventory.locationData({ locationId: id })
        .then((res) => {
          if (res.data.status === 200) {
            this.locationForm = res.data.data;
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
  },
  created() {
    // 没有编辑权限，移除操作列
    if (!this.hasLocationEdit) {
      this.columns.pop();
    }
    this.getWarehouseAbleList();
    this.getWarehouseList();
    this.handleSearch(true);

    if (this.roleType !== 2) {
      this.columns.splice(0, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }
  },
};
</script>
<style lang="less" scoped>
  .header {
    .title {
      color: rgba(0, 0, 0, 0.75);
      font-weight: 500;
      line-height: 20px;
      margin-bottom: 10px;

      > span:first-child {
        padding-right: 8px
      }
    }

    .infos {
      font-size: 13px;
      color: rgba(0, 0, 0, 0.65);
      line-height: 22px;

      > span {
        padding-right: 16px;

        > label {
          padding-left: 5px;
        }
      }
    }
  }
</style>
